<template lang="pug">
div
  .display-wrapper
    .display-dekstop
      img.img-fluid.bg-monitor(src='/assets/img/platform/monitor-image.png')
      .layout-desktop
        img.img-fluid(:src="'/assets/img/themeui/desktop/' + imageURL + '.jpg?v1'")
    .display-mobile
      img.img-fluid.bg-mobile(src='/assets/img/platform/mobile-image.png')
      .layout-mobile
        img.img-fluid(:src="'/assets/img/themeui/mobile/' + imageURL + '.jpg?v1'")

  .text-center.mt-3
    .text-xs.text-grey *{{ $t('message.previewImageForIllustrationOnly') }}
    .text-xs.text-grey *{{ $t('message.actualResultMayVary') }}

</template>
<script>

export default {
    props: {
        imageURL: {
            type: String,
            default: null
        }
    },
}
</script>
